// @flow

// Effect Managers
import { call, fork, put, race, take } from 'redux-saga/effects'

// Utils
import traverse from 'fc-utils/traverse'

// LogRocket
import { initializeLogRocket } from '../../../../dom/src/logrocket/init'

// Sagas, Action Types, Action Creators
import { __get } from 'hfty-fetch'

import watchLogin from './login'
import watchLogout from './logout'
import watchReceiveToken from './receiveToken'
import watchAcceptEula from './acceptEula'
import checkEula from './checkEula'

import { validateToken, getToken, CREDENTIALS_REMOVED, isBooting } from 'fc-auth'

import { fetchAuthenticatedUser } from 'fc-authenticated-user'

export default function* boot(): Generator<*, *, *> {
  yield fork(watchReceiveToken)
  yield fork(watchAcceptEula)

  let token = yield call(getToken)

  // Validate the token
  if (token) {
    const { validatedToken } = yield race({
      validatedToken: call(validateToken, { __get, token }),
      credentialsRemoved: take(CREDENTIALS_REMOVED),
    })

    if (!validatedToken) {
      yield fork(watchLogin)
      yield put(isBooting({ isAuthenticated: false }))
    } else {
      yield fork(watchLogout)
      const result = yield call(fetchAuthenticatedUser)
      const isLoggingEnabled = traverse(['response', 'client_settings', 'logging'])(result)

      if (isLoggingEnabled) {
        initializeLogRocket(result.model)
      }

      const acceptedEula = yield call(checkEula)
      if (acceptedEula) {
        yield put(isBooting({ isAuthenticated: true }))
      }
    }
  } else {
    yield fork(watchLogin)
    yield put(isBooting({ isAuthenticated: false }))
  }
}
